import styled from 'styled-components';

export const ReadGmailStyles = styled.section``;
